import Layout from '@/layout/Layout.vue'
import { P, ROLES } from '@/config/permissions'

/**
 * Routes Extranet
 *
 * Ces routes utilisent le même composant showAccount.vue que les routes admin,
 * mais avec un contexte différent détecté automatiquement via le chemin `/extranet/`.
 *
 * Le composant showAccount.vue détecte le contexte extranet et adapte :
 * - Les appels API (via clientApiAdapter)
 * - Les permissions (préfixe "extranet" automatique)
 * - L'interface (labels, onglets visibles)
 */
const extranetRoutes = {
  path: '/extranet',
  name: 'Extranet',
  component: Layout,
  redirect: '/extranet/dash',
  hidden: true,
  alwaysShow: false,
  meta: {
    title: 'Extranet',
    icon: 'mdi:web',
    roles: [ROLES.EXTRANET_CLIENT],
    permissions: [P.EXTRANET.VIEW_DASH_COMPTES],
    breadcrumb: false,
  },
  children: [
    // Dashboard client extranet - utilise showAccount.vue
    {
      path: 'dash/:id(\\d+)',
      component: () => import('@/views/accounts/showAccount.vue'),
      name: 'ExtranetDash',
      meta: {
        title: 'Mon compte',
        // Pas de `noCache` : cet ecran recharge lui-meme ses donnees dans
        // `activated()`, hook qui ne se declenche que sous <keep-alive>.
        roles: [ROLES.EXTRANET_CLIENT],
        permissions: [P.EXTRANET.VIEW_DASH_COMPTES],
      },
      hidden: true,
    },

    // Dashboard groupe de clients extranet - conservé séparément car spécifique
    {
      path: 'group/:id_grp(\\d+)',
      component: () => import('@/views/extranet/dashGroup.vue'),
      name: 'ExtranetGroupDash',
      meta: {
        title: 'Mon groupe',
        noCache: true,
        roles: [ROLES.EXTRANET_CLIENT],
        permissions: [P.EXTRANET.VIEW_DASH_COMPTES_GROUP],
      },
      hidden: true,
    },
  ]
}

export default extranetRoutes
